<script>
  import { navigateTo } from 'svelte-router-spa';
  import { isLoggedIn } from '../../utils/store';

  async function logout() {
    const response = await fetch(process.env.BACKEND_URL + 'logout', {
      method: 'GET',
      credentials: 'include',
    });

    if (response.ok) {
      isLoggedIn.set(false);
      navigateTo('/login');
    } else {
      console.error(response);
    }
  }
</script>

<button on:click={logout} class="btn btn-outline-danger btn-lg">
  Çıkış Yap
</button>
